export function normalizeDuplicateFormKeys(form: any): void {
    if (!form?.formPanels) {
        return;
    }

    const used = new Set<string>();

    form.formPanels.forEach((panel: any) => {
        (panel.items || []).forEach((item: any) => {
            if (!item?.key) {
                return;
            }

            if (used.has(item.key)) {
                let n = 2;
                while (used.has(`${item.key}__#${n}`)) {
                    n++;
                }
                item.key = `${item.key}__#${n}`;
            }

            used.add(item.key);
        });
    });
}
